import React from 'react'
import { DataTable } from 'primereact/datatable'
import { enums } from '../../../constants'
import { REMESSA_TYPES } from '../../../constants/remessaTypes'
import utils from '../../../utils/index'
import { Card } from 'primereact/card'
import { TabPanel, TabView } from 'primereact/tabview'
import _ from 'lodash'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'

export const ConsultaRemessaForm = (props) => {
  const record = props.record
  let identificacao = record.identificacao
  const itens = _.get(record, 'itens', [])
  const logs = _.get(record, 'logs', [])
  const itensComErroSelecionados = _.get(props, 'selection', []).filter((item) => item.status === 2)
  const totalItensComErroSelecionados = itensComErroSelecionados.length
  const hasSelectedItensComErro = totalItensComErroSelecionados > 0
  const tiposComReprocessamento = [
    REMESSA_TYPES.BOLETO.id,
    REMESSA_TYPES.VINDI_BOLETO.id,
    REMESSA_TYPES.BOLETO_BRADESCO.id,
    REMESSA_TYPES.BOLETO_SICOOB.id,
    REMESSA_TYPES.BOLETO_SANTANDER.id,
    REMESSA_TYPES.BOLETO_ITAU.id,
    REMESSA_TYPES.BOLETO_CAIXA.id,
    REMESSA_TYPES.BOLETO_SICREDI.id,
    REMESSA_TYPES.CNAB_400.id,
  ]
  const canShowReprocessarButton = tiposComReprocessamento.includes(record.tipo)

  function getDadosGerais() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          {canShowReprocessarButton && (
            <div style={{ marginBottom: '1rem' }}>
              <Button
                label={`${utils.getMessage(
                  props.messages,
                  'consultaremessa.label.reprocessar'
                )} ${totalItensComErroSelecionados} ${utils.getMessage(
                  props.messages,
                  'consultaremessa.label.lancamentos'
                )}`}
                type="button"
                onClick={props.reprocessar}
                disabled={!hasSelectedItensComErro}
                style={{ width: 'auto' }}
              />
            </div>
          )}
          <DataTable
            selection={props.selection}
            onSelectionChange={props.onSelectionChange}
            reorderableColumns={true}
            resizableColumns={true}
            columnResizeMode="expand"
            filterDisplay="row"
            ref={props.dataTableItens}
            paginator={true}
            emptyMessage=" "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={itens}
            onRowSelect={props.onRowSelect}
            totalRecords={itens.length}
          >
            {props.colunasItens}
          </DataTable>
          <br />
          <div style={{ textAlign: 'right', margin: '7px' }}>
            <strong>Total: </strong> {itens.length}
          </div>
        </div>
      </div>
    )
  }
  function getDadosLogs() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <DataTable
            resizableColumns={true}
            columnResizeMode="expand"
            ref={props.dataTableLogs}
            paginator={true}
            emptyMessage="  "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={logs}
            totalRecords={logs.length}
          >
            {props.colunasLogs}
          </DataTable>
        </div>
      </div>
    )
  }
  function getContent() {
    return (
      <>
        <Accordion>
          <AccordionTab header={utils.getMessage(props.messages, 'consultaremessa.label.filtros')}>
            <div className="p-grid p-fluid">
              <div className="p-col-12"></div>
              <InputTextarea
                value={record.parametros}
                name="parametros"
                rows={1}
                cols={100}
                autoResize={true}
                style={{ marginBottom: '10px;' }}
              />
            </div>
          </AccordionTab>
        </Accordion>
        <br />
        <TabView activeIndex={props.state.activeIndex} onTabChange={(e) => props.changeActiveIndex(e.index)}>
          <TabPanel header={utils.getMessage(props.messages, 'consultaremessa.label.dadosgerais')}>
            {getDadosGerais()}
          </TabPanel>
          <TabPanel header={utils.getMessage(props.messages, 'consultaremessa.label.logs')}>{getDadosLogs()}</TabPanel>
        </TabView>
      </>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card
          title={`${utils.getMessage(props.messages, 'consultaremessa.label.consultaRemessas')} ${record.oid || ''}`}
          subTitle={identificacao || ''}
        >
          {getContent()}
        </Card>
      </div>
    </div>
  )
}
